import { Link } from 'react-router-dom';
import styles from './Nav.module.scss';
import { AppRoutes } from 'UI/router/AppRoutes';
import { Separator } from '../separator';
import logo from 'assets/logo/logo-text.png';

export function Nav(): React.ReactElement {
  return (
    <div className={styles.menu}>
      <div className={styles.menuHeader}>
        <img src={logo} alt="logo" className={styles.logo} />
      </div>
      <Separator />
      <div className={styles.menuBody}>
        <Link className={styles.menuBodyLink} to={AppRoutes.Dashboard.CategoriesManagement()}>
          <span>Categories Management</span>
        </Link>
        <Link className={styles.menuBodyLink} to={AppRoutes.Dashboard.InstagramContentModeration()}>
          <span>Instagram Content Moderation</span>
        </Link>
        <Link className={styles.menuBodyLink} to={AppRoutes.Dashboard.UserManagement()}>
          <span>User Management</span>
        </Link>
      </div>
    </div>
  );
}
